import React, {useEffect, useState} from 'react';

import {makeApiCall} from "../../Api/makeApiCall";
import moment from "moment-timezone";

function LastKeithFilesRun() {

    const [lastRunDate, setLastRunDate] = useState(undefined);

    useEffect(() => {
        makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/airflow/daglogs?processName=get_metadata_keith`)
            .then(data => data.metadata
                .filter(dagRun => dagRun.status === 'success')
                .map(dagRun => dagRun.executionDate)
            )
            .then((executionDates) => {
                const latestExecutionDate = executionDates.sort()[executionDates.length - 1]
                if (latestExecutionDate) {
                    moment.tz.setDefault('America/Chicago')
                    const lastRunDate = moment(latestExecutionDate).format('YYYY-MM-DD hh:mm:ss')
                    setLastRunDate(lastRunDate)
                }
            })
    }, []);

    return (<>
            {lastRunDate && <span data-testid={'get_metadata_keith_label'}
                                  className={'last-run-time-stamp'}>{`get_metadata_keith last ran: ${lastRunDate}`}</span>}
        </>
    )
}

export default LastKeithFilesRun;
